import { ChevronRight, Github, Youtube } from 'lucide-react';
import { Link } from '@tanstack/react-router';
import { useClerk } from '@clerk/clerk-react';
import { useState } from 'react';
import Preferences from '@/auth/Preferences';
import DashboardWrapper from './DashboardWrapper';
import LogoutDialog from '../components/ui/LogoutDialog';

const MorePageContent = () => {
    const { signOut, openUserProfile } = useClerk();
    const [isPreferencesOpen, setIsPreferencesOpen] = useState(false);

    const handleLogout = async () => {
        await signOut();
        window.location.href = '/';
    };

    const sections = [
        {
            title: 'More',
            items: [
                { name: 'View Leaderboards', path: '/leaderboard' },
                { name: 'Explore Courses', path: '/explore-courses' },
                { name: 'My Achievements', path: '/achievements' },
                { name: 'My Billing/Finance', path: '/billing' },
            ],
        },
        {
            title: 'My Account',
            items: [
                // TODO: TopBar Update
                // { name: 'My Profile', path: '/account-settings' },
                { name: 'Manage Account', onClick: () => openUserProfile() },
                { name: 'Preferences', onClick: () => setIsPreferencesOpen(true) },
                { name: 'Notifications', path: '/notifications' },
                // { name: 'My Billing/Finance', path: '/billing' },
            ],
        },
        {
            title: 'Others',
            items: [
                {
                    name: 'Refer and Earn (affiliate program)',
                    path: 'https://zinduaschool.com/refer/',
                },
                {
                    name: 'Request Feature or Report Bug',
                    path: 'https://teable.zinduaschool.com/share/shr02vkM9ypwxebB85H/view',
                },
                {
                    name: 'Legal Policies (Terms/Policy)',
                    path: 'https://zinduaschool.com/legal/?srsltid=AfmBOoqOlEpreLAWY_4aXikZqmMIQ-xz0oJ1N_XTy_ZHRleJJmVWyqAf#terms',
                },
            ],
            // TODO: rolling based update  based n the sidebar in  md and large screens
        },
    ];

    return (
        <div className="p-4">
            {sections.map(section => (
                <div key={section.title} className="mb-6">
                    <h3 className="text-h3 font-semibold mb-2">{section.title}</h3>
                    <ul className="list-none">
                        {section.items.map(item => (
                            <li
                                key={item.name}
                                className="px-2 py-1 text-neutral-700 hover:text-primary hover:bg-neutral-200 cursor-pointer"
                            >
                                {item.onClick ? (
                                    <button
                                        onClick={item.onClick}
                                        className="flex items-center justify-between py-2 w-full text-left"
                                    >
                                        <span>{item.name}</span>
                                        <ChevronRight size={20} />
                                    </button>
                                ) : item.path ? (
                                    item.path.startsWith('http') ? (
                                        <a
                                            href={item.path}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="flex items-center justify-between py-2"
                                        >
                                            <span>{item.name}</span>
                                            <ChevronRight size={20} />
                                        </a>
                                    ) : (
                                        <Link
                                            to={item.path}
                                            preload="intent"
                                            preloadDelay={0}
                                            className="flex items-center justify-between py-2"
                                        >
                                            <span>{item.name}</span>
                                            <ChevronRight size={20} />
                                        </Link>
                                    )
                                ) : (
                                    item.component
                                )}
                            </li>
                        ))}
                    </ul>
                </div>
            ))}
            <div className="">
                <h2 className="text-lg font-semibold mb-2"></h2>
                <ul className="list-none">
                    <LogoutDialog onConfirm={handleLogout} />
                </ul>
            </div>
            <Preferences isOpen={isPreferencesOpen} onClose={() => setIsPreferencesOpen(false)} />

            <div className="flex items-center justify-center gap-6 mt-12">
                <a
                    href="https://discord.gg/mXVPnfEh4t"
                    target="_blank"
                    className="text-neutral-500 hover:text-neutral-700 hover:bg-neutral-200 rounded-md w-5 h-5"
                >
                    <svg
                        width="21"
                        height="17"
                        viewBox="0 0 21 17"
                        fill="currentColor"
                        xmlns="http://www.w3.org/2000/svg"
                        className="w-5.5 h-5.5"
                    >
                        <path d="M6.92475 10.088C5.88475 10.088 5.03675 9.143 5.03675 7.987C5.03675 6.831 5.86375 5.885 6.92575 5.885C7.97575 5.885 8.83575 6.83 8.81475 7.987C8.81475 9.143 7.97575 10.088 6.92475 10.088ZM13.8987 10.087C12.8587 10.087 12.0087 9.142 12.0087 7.986C12.0087 6.83 12.8377 5.884 13.8987 5.884C14.9487 5.884 15.8087 6.829 15.7887 7.986C15.7887 9.142 14.9597 10.087 13.8987 10.087ZM8.52975 0.563L8.22175 0L7.58775 0.106C6.15105 0.34612 4.75275 0.776573 3.42975 1.386L3.20175 1.491L3.05975 1.701C0.446748 5.554 -0.270253 9.349 0.0847473 13.076L0.123747 13.483L0.453747 13.723C1.99085 14.851 3.70775 15.7108 5.53175 16.266L6.32175 16.508L7.43475 13.792C9.34475 14.264 11.4647 14.264 13.3737 13.792L14.4807 16.509L15.2707 16.267C17.0963 15.7132 18.8142 14.8526 20.3507 13.722L20.6777 13.484L20.7177 13.082C21.1537 8.762 20.0207 4.999 17.7597 1.698L17.6177 1.49L17.3897 1.386C16.0672 0.779106 14.6705 0.34875 13.2357 0.106L12.6177 0.00300002L12.3037 0.545C12.2157 0.695 12.1267 0.865 12.0407 1.038C10.9559 0.926802 9.86257 0.926802 8.77775 1.038C8.69275 0.868 8.60775 0.704 8.52975 0.563ZM5.11975 12.852C5.31675 12.966 5.52475 13.078 5.72975 13.18L5.28075 14.276C4.06625 13.8335 2.91403 13.2359 1.85275 12.498C1.62775 9.36 2.26575 6.193 4.41675 2.928C5.32462 2.52853 6.27085 2.22262 7.24075 2.015C7.30075 2.14 7.35675 2.263 7.40275 2.371L7.67575 3.014L8.36775 2.913C9.72383 2.71422 11.1017 2.71422 12.4577 2.913L13.1477 3.013L13.4197 2.371C13.4667 2.259 13.5217 2.137 13.5797 2.015C14.5567 2.225 15.5027 2.535 16.4077 2.93C18.2827 5.75 19.2287 8.896 18.9537 12.497C17.8919 13.2354 16.739 13.8334 15.5237 14.276L15.0787 13.181C15.2847 13.079 15.4927 12.967 15.6917 12.852C16.1817 12.57 16.7087 12.218 17.0447 11.882L15.7647 10.602C15.6017 10.766 15.2417 11.022 14.7877 11.284C14.3437 11.54 13.9027 11.747 13.6207 11.84C11.6177 12.503 9.19275 12.503 7.18875 11.84C6.90775 11.747 6.46675 11.54 6.02275 11.284C5.56875 11.023 5.20875 10.766 5.04475 10.602L3.76475 11.882C4.10175 12.218 4.62975 12.57 5.11975 12.852Z" />
                    </svg>
                </a>
                <a
                    href="https://github.com/zinduaschool"
                    target="_blank"
                    className="text-neutral-500 hover:text-neutral-700 hover:bg-neutral-200 rounded-md w-5 h-5"
                >
                    <Github />
                </a>
                <a
                    href="#"
                    // target="_blank"
                    className="text-neutral-500 hover:text-neutral-700 hover:bg-neutral-200 rounded-md w-5.5 h-5.5 flex justify-center items-center"
                >
                    <svg
                        width="20"
                        height="12"
                        viewBox="0 0 20 12"
                        fill="currentColor"
                        xmlns="http://www.w3.org/2000/svg"
                        className="w-5.5 h-5.5"
                    >
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M6 0C7.5913 0 9.11742 0.632141 10.2426 1.75736C11.3679 2.88258 12 4.4087 12 6C12 7.5913 11.3679 9.11742 10.2426 10.2426C9.11742 11.3679 7.5913 12 6 12C4.4087 12 2.88258 11.3679 1.75736 10.2426C0.632141 9.11742 0 7.5913 0 6C0 4.4087 0.632141 2.88258 1.75736 1.75736C2.88258 0.632141 4.4087 0 6 0ZM15 1C16.5 1 17.5 3.239 17.5 6C17.5 8.761 16.5 11 15 11C13.5 11 12.5 8.761 12.5 6C12.5 3.239 13.5 1 15 1ZM19 1.5C19.38 1.5 19.712 2.327 19.88 3.746L19.927 4.189L19.946 4.424L19.976 4.918L19.986 5.177L19.998 5.718L20 6L19.998 6.282L19.986 6.823L19.976 7.083L19.946 7.576L19.926 7.811L19.881 8.254C19.712 9.674 19.381 10.5 19 10.5C18.62 10.5 18.288 9.673 18.12 8.254L18.073 7.811L18.054 7.576L18.024 7.082L18.014 6.823L18.002 6.282V5.718L18.014 5.177L18.024 4.917L18.054 4.424L18.074 4.189L18.119 3.746C18.288 2.326 18.619 1.5 19 1.5ZM6 2C4.93913 2 3.92172 2.42143 3.17157 3.17157C2.42143 3.92172 2 4.93913 2 6C2 7.06087 2.42143 8.07828 3.17157 8.82843C3.92172 9.57857 4.93913 10 6 10C7.06087 10 8.07828 9.57857 8.82843 8.82843C9.57857 8.07828 10 7.06087 10 6C10 4.93913 9.57857 3.92172 8.82843 3.17157C8.07828 2.42143 7.06087 2 6 2ZM14.956 3.403C14.593 4.203 14.5 5.134 14.5 6C14.5 6.866 14.592 7.798 14.956 8.597C14.974 8.635 15.026 8.635 15.044 8.597C15.407 7.797 15.5 6.866 15.5 6C15.5 5.134 15.408 4.202 15.044 3.403C15.0403 3.39444 15.0341 3.38715 15.0263 3.38203C15.0185 3.37691 15.0093 3.37418 15 3.37418C14.9907 3.37418 14.9815 3.37691 14.9737 3.38203C14.9659 3.38715 14.9597 3.39444 14.956 3.403Z"
                        />
                    </svg>
                </a>
                {/* <a
                        href="https://chat.whatsapp.com/I0g3B7syYiD4IxezErSi3p"
                        target="_blank"
                        className="text-neutral-500 hover:text-neutral-700 hover:bg-neutral-200 flex justify-center items-center "
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            fill="currentColor"
                            viewBox="0 0 16 16"
                        >
                            <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232" />
                        </svg>
                    </a> */}
                <a
                    href="https://youtube.com/@zinduaschool"
                    target="_blank"
                    className="text-neutral-500 hover:text-neutral-700 hover:bg-neutral-200 rounded-md w-5 h-5"
                >
                    <Youtube />
                </a>
            </div>
            <div className="flex items-center justify-center mt-4">
                <p className="text-neutral-500 line-clamp-1">
                    &copy; Zindua Coding School LTD {new Date().getFullYear()}
                </p>
            </div>
        </div>
    );
};

const MorePage = () => {
    return (
        <DashboardWrapper>
            <MorePageContent />
        </DashboardWrapper>
    );
};

export default MorePage;
